import React from 'react';

import NavBar from '../../../components/common/navbar';
import SideBar from '../../../components/modules/left_sidebar';
import { Button } from '@progress/kendo-react-buttons'
import $ from 'jquery'
import RightPopModalForm from '../../../components/common/RightPopModalForm';
import services from '../../../services';
import CashierDetails from './CashierDetails';
const queryString = require('query-string');
var moment = require('moment')
const Administration = false;
/*
Formato de solicitação padrão para todas as APIs de listagem   
*/
const listdefaultRequest = {"Filters": {
    "entity_id": null,
     start_date: null, end_date: null, 
    "is_paid":"1",
    "type":null,
    "is_doc_generated":null,
    invoice_id : null,
    for_invoice:null
    }, "SortBy": "", "IsSortTypeDESC": true, "IsPagination": false, "Page": 1, "PageSize": 100 }

 
/* Array de configurações estáticas da página */ 

const optionMenuArray = 
// [
    {
        // sub_menu: [
        //     {
                linkData: {
                    filters: {
                        Tabs: {
                            Período: [
                                {
                                    key: 'RangePicker',
                                    displayKey: "intervalo de datas",
                                    inputType: "RangePicker"
                                }
                                
                            ]
                        },
                        checkbox: []
                    },
                    columnkeyMap: {
                        "codart":"Codart",
                        "Descrição":"Descrição",
                        "unit": "Unidade",
                        "per_services_amount": "Quantidade de serviços",
                        "service_tax": "Iva",
                        "tax_type": "Iva Tipo",
                        "tax_percent": "Iva %",
                        "valor_cativo": "Iva Cativo",
                        "valor": "Valor"
                    },
                    actionbuttons: { Edit: false, Redirect: false, Delete: true, detailPopUp : false},
                    popUpTabName: "Consultar Conta",
                    listApilink: "Revenue/GetInvoiceList",
                    listdefaultRequest: listdefaultRequest,
                    requestMethod: "post",
                    notAction:false,
                    OpenAndCloseCashier:true,
                    prevPageName: "",
                    prevPageLink: "",
                    currentPath:"revenue_conta",
                    nevOptionChange:[
                        {
                            name: 'Efetuar Venda',
                            url: 'cashier',
                            tableName: "CaixaTable",
                        },{
                            name: 'Depósitos',
                            url: 'cashier',
                            tableName: "CaixaTable",
                        },{
                            name: 'Folha de Caixa',
                            url: 'cashier',
                            tableName: "CaixaTable",
                        },
                    ],
                    navbarOptionsYear: false,
                    TitleBarpath: "/vindima_Conta_de_Produtor",
                    TitleBartitle: "Caixa",
                    onlyEntityAction:true,
                    TitleBarlogo: "auditing",
                    groupfield: []
                }
        //     },
        // ]
    }
// ]


class Cashier extends React.Component {

    /* Primeiro passo na acomodação da classe */

    constructor(props) {
        super(props);
        this.state = this.setLinkDataMethod()
    }

/* Esta é a primeira etapa após o construxctor para carregar este componente  */

 componentDidMount() {
     console.log("lklklkl")
        let parsed = this.props.location.state && this.props.location.state.paramoption ||{};
        this.setState(this.setLinkDataMethod(parsed))
    }

     /* Esta função irá chamar automaticamente quando o estado da página mudar  */
     componentDidUpdate = (prevProps) => {
        let parsed = this.props.location.state && this.props.location.state.paramoption ||{};
        let prevParsed = prevProps.location.state && prevProps.location.state.paramoption || {}
        if ( prevParsed.name !== parsed.name) {
            this.setState(this.setLinkDataMethod(parsed))
        }
    }
    /*  Este método é usado para carregar dados estáticos reletados da página com base nas alterações de url  */
    setLinkDataMethod = (parsed) => {
       // console.log("gsdsgf",parsed)
        if(!parsed){
            parsed = {}
        }
        // let parsed = this.props.location.state && this.props.location.state.paramoption || {}
        if(Object.keys(parsed).length === 0 && this.state && this.state.parsed){
            parsed = this.state.parsed
        }
        if(parsed.back){
            parsed = {}
            parsed["serviceNo"] = 0 
        }
        console.log("......",parsed)
        let topBarMenu = this.props.location && this.props.location.state && this.props.location.state.topBarMenu
        if(topBarMenu){
            this.setState({topBarMenu})
        }
        if(parsed){
            this.setState({parsed})
        }
        let selectOption = { ...optionMenuArray };
        let linkData = selectOption.linkData;
        if (!parsed.name) {
            linkData.prevPageName = "";
            linkData.prevPageLink = "";
            linkData.tableName = ""
        }
        parsed.name = parsed.name ? parsed.name : ""
        parsed.url = parsed.url ? parsed.url : ""
        parsed.tableName = parsed.tableName ? parsed.tableName : ""
        if (parsed.name) {
            linkData.prevPageName = parsed.name;
            linkData.prevPageLink = parsed.url;
            linkData.tableName = parsed.tableName;
        }
        let year = new Date();
        year = year.getFullYear()
        console.log("oooooo",parsed)
        return {
            noOption: true,
            popUpForm: null,
            year: year,
            linkData: linkData,
            pageOption: "",
            Tab: null,
            parsed: parsed,
            tableName: linkData.tableName,
            search: window.location.search,
            topBarMenu:topBarMenu,
            popUpForm2:null
        }
    }

/*  Este método é usado para carregar dados estáticos reletados da página com base nas alterações de url  */

// setLinkDataMethod = () => {
//         let mainIndex = 0;
//         let subIndex = 0;
//         const parsed = queryString.parse(this.props.location.search);
//         if (parsed.m) {
//             mainIndex = parsed.m;
//         }
//         if (parsed.s) {
//             subIndex = parsed.s;
//         }
//         let selectOption = optionMenuArray[mainIndex].sub_menu[subIndex];
//         let selectedMainOption = optionMenuArray[mainIndex]
//         let year = new Date();
//         year = year.getFullYear();
//         return {
//             year: year,
//             noOption: true,
//             Tab: null,
//             popUpForm: null,
//             entity_details: {
//                 busEntidade: {},
//                 currentEntityBalance: 0,
//                 billingAddress: []
//             },
//             currency_list: [],
//             tax_list: [],
//             TransMethods_list: [],
//             selectedtitelotion: selectOption.display,
//             selectedMainOption: selectedMainOption.main,
//             linkData: selectOption.linkData,
//             parsed: queryString.parse(this.props.location.search)
//         }
//     }

/*  Sempre que o usuário alterar qualquer opção do front end, este método irá atualizar o url da página de acordo com essa opção  */

changeOption = (prevPageName, prevPageLink) => {
        // window.location = "/revenue_receitas?m=" + mainIndex + "&s=" + subIndex;
        // return;
        let linkData = { ...this.state.linkData }
        linkData.prevPageName = prevPageName;
        linkData.prevPageLink = prevPageLink;
        this.setState({
            linkData
        })

    }

updateParam=()=>{
    let linkData={...this.state.linkData}
    let parsed = {...this.state.parsed};
    parsed["serviceNo"] = 0 ;
    linkData.prevPageName = "";
    linkData.prevPageLink = "";
    linkData.tableName = "";
    this.setState({
        parsed,
        linkData
    })

}    



/*  Usado para alterar o ano da página completa e filtrar os dados de acordo  */

updateYear = (year) => {
        this.setState({
            year: year
        })
    }

/*  Para renderizar o conteúdo html da página   */

render() {
    let topBarMenu = this.props.location && this.props.location.state && this.props.location.state.topBarMenu
        return (
            <div className="dashboard">
                <NavBar 
                    date={new Date()} 
                    linkData={this.state.linkData}  
                    noOption={this.state.noOption}  
                    year={this.state.year} 
                    moduleName="Revenue"
                    parsed={this.state.parsed}
                    topBarMenuOption={topBarMenu} 
                    updateParam={()=>this.updateParam()}
                    updateYear={(year) => this.updateYear(year)} 
                />
                <SideBar Administration={Administration} />
                <div className="container-fluid">
                    <CashierDetails 
                        singleentity={true}
                        parsed={this.state.parsed}
                        // selectedMainOption={this.state.selectedMainOption} 
                        date={new Date()} year={this.state.year} 
                        topBarMenuOption={topBarMenu}
                        changeOption={(mainIndex, subIndex) => this.changeOption(mainIndex, subIndex)} 
                        optionMenuArray={optionMenuArray} 
                        linkData={this.state.linkData}
                        // selectedtitelotion={this.state.selectedtitelotion} 
                    />
                </div>
                <button type="hidden" data-toggle="modal" data-target="#popup-modal" className="modelpopup"></button>
                <div className="modal left-popup" id="popup-modal">
                    <div className="modal-dialog modal-lg">
                        {
                            this.state.popUpForm
                        }
                    </div>
                </div>

                {/* <div className="modal left-popup" id="openClose-modal">
                    <div className="modal-dialog modal-lg">
                        {
                            this.state.popUpForm2
                        }
                    </div>
                </div> */}
            </div>
        )
    }
}


export default Cashier;